export var SoilDepth;
(function (SoilDepth) {
    SoilDepth["Low"] = "0";
    SoilDepth["Normal"] = "1";
    SoilDepth["High"] = "2";
})(SoilDepth || (SoilDepth = {}));
